function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "create-outline",
  transform: "translate(-3 -2.875)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11813",
  "data-name": "Path 11813",
  d: "M34.692,18.058V35.419a3.775,3.775,0,0,1-3.775,3.775H8.275A3.775,3.775,0,0,1,4.5,35.419V12.775A3.775,3.775,0,0,1,8.275,9h15.8",
  transform: "translate(0 1.923)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11814",
  "data-name": "Path 11814",
  d: "M33.252,3.87a1.515,1.515,0,0,0-2.191-.052L29.893,4.979a.755.755,0,0,0,0,1.067l1.069,1.068a.755.755,0,0,0,1.069,0L33.17,5.981a1.535,1.535,0,0,0,.081-2.112Z",
  transform: "translate(8.605)",
  fill: "#ac1ede",
  stroke: "#ac1ede",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11815",
  "data-name": "Path 11815",
  d: "M32.679,6.391l-17.032,17a.849.849,0,0,0-.217.37L14.64,26.11a.369.369,0,0,0,.459.459l2.344-.788a.849.849,0,0,0,.37-.217l17-17.035a.849.849,0,0,0,0-1.194l-.939-.943a.849.849,0,0,0-1.2,0Z",
  transform: "translate(3.461 0.946)",
  fill: "#ac1ede",
  stroke: "#ac1ede",
  strokeWidth: 1
}));

var SvgCreateOutline = function SvgCreateOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39.848,
    height: 39.742,
    viewBox: "0 0 39.848 39.742",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreateOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/create-outline.7bd90bac.svg";
export { ForwardRef as ReactComponent };